// extracted by mini-css-extract-plugin
export default {"wrapper":"OurClub_wrapper__KUx3E","slider":"OurClub_slider__Z5nfH","imgAdaptiveSub":"OurClub_imgAdaptiveSub__GoBdn","imgContainer":"OurClub_imgContainer__+E-3A"};